import fisrtProject from '../images/firstProject.png';
import marvelGenerator from '../images/marvelGenerator.png'
import alienAttack from '../images/alienAttack.png'
import playAlong from '../images/playAlong.png'
import pokemonCrud from '../images/pokemonCrud.png'
import seconPortfolio from '../images/seconPortfolio.png';
import Kbook from '../images/Kbook.png';
import recipeProject from '../images/recipeProject.png'
export const projectInfo = [
    { 
      projectName: 'Kbook',
      imageUrl: Kbook,
      projectUrl: "https://kbook-user-site.onrender.com",
      intro: "A full-stack application with M.E.R.N stack, using Redux for global state and Material UI for user interface",
      techUse: "M.E.R.N stack, Redux, Material UI",
      GitHub: 'https://github.com/NhanKhangJ/kbook-client-side',
      type: ["All", "Web App", "Mobile App" ,"Frontend", "Backend"]
    },
    { 
      projectName: 'Pokemon Crud',
      imageUrl: pokemonCrud,
      projectUrl: "https://pokemon-cruc.onrender.com/pokemon",
      intro: "A CRUD application with express React views, express server, Mongdb database, Nodejs enviroment.",
      techUse: "M.E.R.N stack, CSS inline styling",
      GitHub:  'https://github.com/NhanKhangJ/Pokemon_express.git',
      type: ["All", "Web App", "Frontend", "Backend"]
    },
    { 
      projectName: 'Shopping Recipe',
      imageUrl: recipeProject,
      projectUrl: "https://angular-recipe-firebase.onrender.com",
      intro: "A CRUD application with Angular and Firebase",
      techUse: "Angular, RxJs, Bootstrap, Firebase",
      GitHub: 'https://github.com/NhanKhangJ/shopping-recipe',
      type: ["All", "Web App", "Frontend"]
    },
    { 
      projectName: 'Play along',
      imageUrl: playAlong,
      projectUrl: "https://nhankhangj.github.io/GameOn/",
      intro:"My favorite project with more oriented code with new logic and different ways to approach.",
      techUse: "HTML5, CSS3, JS",
      GitHub: 'https://github.com/NhanKhangJ/GameOn.git',
      type: ["All","Web App","Frontend"]
    },
    { 
      projectName: 'Second Portfolio',
      imageUrl: seconPortfolio,
      projectUrl: "/",
      intro: "Happy to see my Portfolio become more professional and combine useful frameworks.",
      techUse: "M.E.R.N stack, Redux, Bootstrap",
      GitHub: 'https://github.com/NhanKhangJ/Portfolio.git',
      type: ["All", "Web App", "Mobile App", "Frontend", "Backend"]
    },
    { 
      projectName: 'Marvel Movies Generator',
      imageUrl: marvelGenerator,
      projectUrl: "https://nhankhangj.github.io/quotes-generator/",
      intro:"Focus on Praticing DOM manipulation and CSS grid layouts, also CSS properties.",
      techUse: "HTML5, CSS3, JS",
      GitHub: 'https://github.com/NhanKhangJ/quotes-generator',
      type: ["All", "Web App", "Mobile App" ,"Frontend"]
   },
    { 
      projectName: 'First Portfolio',
      imageUrl: fisrtProject,
      projectUrl: "https://nhankhangj.github.io/NKL-week1-site/index.html",
      intro:"This is my first project for Pre-work assignment with minimum of Html and css styling requirement.",
      techUse: "HTML5, CSS3, JS",
      GitHub: 'https://github.com/NhanKhangJ/NKL-week1-site',
      type: ["All", "Web App","Mobile App" ,"Frontend"]
   },
   { 
      projectName: 'Alien Attack',
      imageUrl: alienAttack,
      projectUrl: "https://nhankhangj.github.io/ALIEN-ATTACK/",
      intro:"Use Obeject Oriented JavaScript, sharpen DOM manipulation skills and CSS flexbox.",
      techUse: "HTML5, CSS3, JS",
      GitHub: 'https://github.com/NhanKhangJ/ALIEN-ATTACK.git',
      type: ["All", "Web App", "Frontend"]
   }
]